import { render, staticRenderFns } from "./group_registration.vue?vue&type=template&id=1ff60b52&scoped=true&"
import script from "./group_registration.vue?vue&type=script&lang=ts&"
export * from "./group_registration.vue?vue&type=script&lang=ts&"
import style0 from "./group_registration.vue?vue&type=style&index=0&id=1ff60b52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff60b52",
  null
  
)

export default component.exports